import { jsx as _jsx } from "react/jsx-runtime";
import { getSellableItemForSiteByHopk, loadItemByHopk, logger } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { useOccConfig } from '../../context/occ/hooks/use-occ-config';
import { useMemberRewards } from '../../hooks/use-member-rewards';
import { withComponentWrapper } from '../../utils/with-component-wrapper';
import { SingleItemPickerItemList } from './subcomponents/item-list';
import { SingleItemPickerMessage, SingleItemPickerMessageType } from './subcomponents/message';
import { SingleItemPickerSkeleton } from './subcomponents/skeleton';
import { mapSingleItemPickerContext, SingleItemPickerContextInstance } from './types/context';
import { defaultSingleItemPickerProps, singleItemPickerPropsValidator } from './types/props';
const b = bemClassBuilder('v-single-item-picker');
export const SingleItemPicker = observer(props => {
    const { enableSkeletonLoadingIndicators } = useOccConfig();
    const { itemHopk, siteId, displayText, assets } = props;
    const [failedToLoadData, setFailedToLoadData] = useState(false);
    const sellableItem = getSellableItemForSiteByHopk(siteId, itemHopk);
    useEffect(() => {
        (async () => {
            try {
                // Will throw an error if the item cannot be found, or is not supported.
                await loadItemByHopk(siteId, itemHopk);
            }
            catch (error) {
                setFailedToLoadData(true);
                logger.error(`Failed to load item with HOPK ${itemHopk} for site ${siteId}. ${error}`);
            }
        })();
    }, [itemHopk, siteId]);
    // Load member rewards to show reward-restricted prices.
    useMemberRewards();
    const context = mapSingleItemPickerContext(props);
    if (failedToLoadData) {
        return (_jsx(SingleItemPickerMessage, { messageType: SingleItemPickerMessageType.FailedToLoadData, displayText: displayText, assets: assets }));
    }
    if (!sellableItem)
        return enableSkeletonLoadingIndicators ? _jsx(SingleItemPickerSkeleton, {}) : null;
    return (_jsx("div", Object.assign({ className: b.block() }, { children: _jsx(SingleItemPickerContextInstance.Provider, Object.assign({ value: context }, { children: _jsx(SingleItemPickerItemList, { sellableItem: sellableItem }) })) })));
});
SingleItemPicker.displayName = 'SingleItemPicker';
/**
 * The **Single Item Picker** component renders a single item for selection.
 */
export const SingleItemPickerComponent = withComponentWrapper(SingleItemPicker, defaultSingleItemPickerProps, singleItemPickerPropsValidator);
